<template>
    <div class="w-100 d-block">
        <div
            class="w-auto mb-0 text-gray-dark text-center py-12 d-flex justify-content-center align-items-center"
        >
            <span class="mr-10 font--16 lh--20">{{
                ucfirst($t("common.loading"))
            }}</span>

            <span class="bounce1 rounded-circle bg-gray-dark" />

            <span class="bounce2 rounded-circle bg-gray-dark" />

            <span class="bounce3 rounded-circle bg-gray-dark" />
        </div>
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"

export default {
    methods: { ucfirst },
}
</script>

<style scoped>
[class^="bounce"] {
    animation: bouncing 1.25s infinite ease-in-out both;
    width: 0.5rem;
    height: 0.5rem;
}

.bounce1 {
    animation-delay: -0.3s;
}

.bounce2 {
    animation-delay: -0.15s;
}

@keyframes bouncing {
    0%,
    80%,
    100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1);
    }
}
</style>
>
